import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, SmBaseService, OperationResult } from '../../core';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class RelatedActionService extends SmBaseService {
	private _cache: Observable<RelatedActionsSettingsModel> = null;

	constructor(
		http: HttpService
	) {
		super(http, 'relatedaction');
	}

	clearCache() {
		this._cache = null;
	}

	getSettings(force?: boolean): Observable<RelatedActionsSettingsModel> {
		if (this._cache == null || force == true) {
			this._cache = this._getAs<RelatedActionsSettingsModel>('settings')
				.pipe(publishReplay(1))
				.pipe(refCount());
		}

		return this._cache;
	}

	getTransitions(statusId: number): Observable<ITransactionTransitionModel[]> {
		return this._getAs<ITransactionTransitionModel[]>('transitions/' + statusId);
	}

	getSituations(): Observable<ITransactionSituationModel[]> {
		return this._getAs<ITransactionSituationModel[]>('situations');
	}

	moveTransactions(model: MoveTransactionModel): Observable<OperationResult> {
		return this._postAs<OperationResult>('move', model);
	}

	sendEmailTransactions(model: SendMailTransactionModel): Observable<OperationResult> {
		return this._postAs<OperationResult>('sendmail', model);
	}

	setSettings(settings: RelatedActionsSettingsModel) {
		this._cache = null;
		return this._post('settings', settings);
	}
}

export interface RelatedActionsSettingsModel {
	situations: Situation[];
	userStatuses: UserStatus[];
}

export interface Situation {
	identifier: number;
	name: string;
	actions: SituationAction[];
}

export interface SituationAction {
	actionCode: string;
	enabled: boolean;
	name: string;
	argument: string;
}

export interface UserStatus {
	id: number;
	name: string;
	actions: UserStatusAction[];
}

export interface UserStatusAction {
	enabled: boolean;
	name: string;
	code: string;
	argument: string;
}

export interface ITransactionTransitionModel {
	targetStatusId: number;
	situation: ITransactionSituationModel;
}

export interface ITransactionSituationModel {
	identifier: number;
	name: string;
	actions: Array<ITransactionActionModel>;
	isSelected: boolean;
}

export interface ITransactionActionModel {
	name: string;
	actionCode: string;
	actionArgument: string;
	isSelected: boolean;
}

export class MoveTransactionModel {
	transactionIds: Array<number>;
	targetStatusId: number;
	actions: Array<RelatedActionModel>;
}

export class SendMailTransactionModel {
	transactionIds: Array<number>;
	messageTemplateCode: string;
	actions: Array<RelatedActionModel>;
}

export class RelatedActionModel {
	actionCode: string;
	actionArgument: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/relatedaction.service.ts